<template>
  <div class="single-gallery-modal">
    <div class="single-gallery-modal-cont">
      <div class="container">
        <div class="row">
          <div class="col-1 hidden-sm"/>
          <div class="col-10">
            <button class="close-modal" @click="hideSingleModal" aria-label="Close modal">
              <svg class="ico ico--20">
                <use xlink:href="#ico-cross"/>
              </svg>
            </button>
            <div class="slide-number">
              <span>
                {{ slideNumber+1 }}
              </span>
              <span>
                /
              </span>
              <span>{{ images.length }}</span>
            </div>
            <swiper class="swiper" :options="swiperOption" @slideChange="setSlideIndex" ref="mySwiper">
              <swiper-slide v-for="image in images">
                <div>
                  <img :src="image.hero" :alt="image.cap"/>
                </div>
              </swiper-slide>
              <div class="swiper-button-prev" slot="button-prev"/>
              <div class="swiper-button-next" slot="button-next"/>
            </swiper>
          </div>
        </div>
      </div>
      <button class="overlay" @click="hideSingleModal" aria-label="Hide modal"/>
    </div>
  </div>
</template>

<script>
import {Swiper, SwiperSlide, directive} from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
export default {
  data: function () {
    return {
      slideNumber: this.slideIndex,
      swiperOption: {
        centeredSlides: true,
        slidesPerView: 'auto',
        initialSlide: this.slideIndex,
        grabCursor: true,
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  props: {
    images: Array,
    slideIndex: Number,
    isSingleModalVisible: Boolean,
  },
  components: {Swiper, SwiperSlide},
  methods: {
    hideSingleModal(){
      this.$emit('toggleSingleGalleryModal', null);
    },
    setSlideIndex(){
      this.slideNumber = this.$refs.mySwiper.$swiper.realIndex;
    },
    keyDownHandler(e) {
      if (this.isSingleModalVisible === true) {
        if (e.keyCode === 37) {
          this.$refs.mySwiper.$swiper.slidePrev();
        } else if (e.keyCode === 39) {
          this.$refs.mySwiper.$swiper.slideNext();
        }
      }
    }
  },
  directives: {
    swiper: directive
  },
  mounted() {
    this.slideNumber = this.slideIndex;
    document.addEventListener('keydown', this.keyDownHandler);
  }
}
</script>

<style lang="scss">
@import 'app/assets/stylesheets/_vars.scss';

.single-gallery-modal {
  position: fixed;
  z-index: 15;
  top: 0;
  left: 0;
  background: $col_white;
  width: 100%;
  height: 100%;

  .single-gallery-modal-cont {
    padding: 4rem 0 .625rem;
    height: calc(100vh - 4.625rem);

    .swiper-container {
      height: calc(100vh - 12rem);
      z-index: 2;

      .swiper-slide {
        height: auto;
        max-height: unset;

        div {
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;

          img {
            width: 100%;
            height: 100%;
            border-radius: 0.25rem;
            object-fit: contain;
          }
        }
      }

      .swiper-button-next, .swiper-button-prev {
        cursor: pointer;
        height: 2rem;
        width: 2rem;
        border-radius: 2rem;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #ffffff7d;
        color: $col_darkgrey;
        transition: .3s;

        &:after {
          font-size: 1rem;
        }

        &:hover {
          transition: .3s;
          background: #efefefc4;
        }
      }

      .swiper-button-next {
        right: 1rem;
      }

      .swiper-button-prev {
        left: 1rem;
      }
    }

    .slide-number {
      position: absolute;
      top: -40px;
      z-index: 3;
      left: calc(50% - 1.188rem);
    }

    .close-modal {
      top: 1rem;
      left: 1rem;
      z-index: 14;
      position: fixed;
      cursor: pointer;
      height: 2rem;
      width: 2rem;
      border-radius: 2rem;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #ffffff4f;
      transition: .3s;

      svg {
        width: .875rem;
        height: .875rem;
      }

      &:hover {
        transition: .3s;
        background: #efefef;
      }
    }
  }
  @media #{$desktop} {
    .single-gallery-modal-cont {
      padding: 5rem 0;
      height: calc(100vh - 10rem);

      .swiper-container {
        height: calc(100vh - 10rem);

        .swiper-button-next, .swiper-button-prev {
          height: 2.5rem;
          width: 2.5rem;
        }

        .swiper-button-next {
          right: 1.25rem;
        }

        .swiper-button-prev {
          left: 1.25rem;
        }
      }

      .close-modal {
        top: 1.5rem;
        left: 1.5rem;
      }
    }
  }
}
</style>